import Vue from 'vue'
import TableChart from '@/components/utils/TableChart'

export default {
  methods: {
    createChartTable (id, data) {
      let block = document.getElementById(id)
      let ComponentClass = Vue.extend(TableChart)
      var instance = new ComponentClass({
        propsData: {
          graphData: this.graphData,
          id: this.id,
          type: this.type
        }
      })
      instance.$mount()
      block.appendChild(instance.$el)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chartTableMix.js